import React, { useEffect, useState } from "react";

import { Box } from "@chakra-ui/react";
import { ReactComponent as CautionRedIcon } from "assets/icons/caution-icon-rounded.svg";
import { ReactComponent as InfoOutlineIcon } from "assets/icons/info-outline.svg";
import { useAuth } from "contexts/auth-context";
import { useIdleTimer } from "react-idle-timer";

import { Button } from "ui/button";
// import { IIdleCheckerProps } from "./types";
import { Modal } from "ui/modal";
import { ModalHeader } from "ui/modal/modal-header";
import { defaultModalCss } from "ui/modal/styles";
import { Heading3, Paragraph3 } from "ui/typography";

const IDLE_COUNT_DOWN = 300000; // 5 minutes
const PROMPT_COUNT_DOWN = 60000; // 1 minute
const IDLE_TIMER_THROTTLE = 500; // split second
const ONE_SECOND = 1000; // 1 second
const COUNTER_INCREMENT_VALUE = 1;
const INITIAL_COUNT = 0;

export const IdleChecker = (/* props: IIdleCheckerProps */) => {
  const { setJustLoggedOut, logOut } = useAuth();
  const [isIdle, setIsIdle] = useState(false);
  const [activityCounter, setActivityCounter] = useState(INITIAL_COUNT);
  const [timeRemaining, setTimeRemaining] = useState(INITIAL_COUNT);
  const [isOpenPrompt, setIsOpenPrompt] = useState(false);

  const onIdle = () => {
    setIsIdle(true);
    logOut();
    setJustLoggedOut(true);
  };

  const onActive = () => {
    setIsIdle(false);
  };

  const onAction = () => {
    setActivityCounter(
      (activityCounter) => activityCounter + COUNTER_INCREMENT_VALUE
    );
  };

  const onPrompt = () => {
    setIsOpenPrompt(true);
  };

  const idleTimer = useIdleTimer({
    onIdle,
    onActive,
    onAction,
    onPrompt,
    timeout: IDLE_COUNT_DOWN,
    promptBeforeIdle: PROMPT_COUNT_DOWN,
    throttle: IDLE_TIMER_THROTTLE,
  });

  const stayLoggedIn = () => {
    setIsOpenPrompt(false);
    idleTimer.reset();
  };

  useEffect(() => {
    const interval = setInterval(() => {
      setTimeRemaining(Math.ceil(idleTimer.getRemainingTime() / ONE_SECOND));
    }, IDLE_TIMER_THROTTLE);

    return () => {
      clearInterval(interval);
    };
  });

  return (
    <>
      <div className="hidden">
        <h1>Idle Check</h1>
        <br />
        <p>Current Status: {isIdle ? "idle" : "active"}</p>
        <p>Action Events: {activityCounter}</p>
        <p>{timeRemaining} seconds remaining</p>
      </div>

      <Modal
        isOpen={isOpenPrompt}
        setIsOpen={setIsOpenPrompt}
        allowOutsideClick={false}
        modalCss={{ ...defaultModalCss, width: "412px" }}
        position="center"
      >
        <Box className="flex flex-col">
          <ModalHeader
            modalType="others"
            HeaderIcon={<CautionRedIcon />}
            className="mb-0"
          />
          <Heading3
            // className="mt-5"
            fontWeight="600"
            textColor="#101828"
            fontSize="18px"
            lineHeight="28px"
          >
            Login Expiring...
          </Heading3>

          <div className="mt-3 text-fade">
            <Paragraph3
              className="mb-2 text-sm"
              fontWeight="400"
              textColor="#475467"
            >
              Your login session is about to expire.
            </Paragraph3>
            <Box className="bg-[#FEF5E7] border border-[#FFEFD8] rounded-2xl p-3 flex items-center gap-[8px]">
              <InfoOutlineIcon className="w-4 h-4" />
              <Paragraph3
                fontSize="14px"
                lineHeight="20px"
                textColor=" #1A202C"
                className="tracking-[0%] text-left"
              >
                You will be automatically logged out in&nbsp;
                <span className="text-[#4F3308] font-semibold whitespace-nowrap">
                  {`${timeRemaining}s`}
                </span>
              </Paragraph3>
            </Box>
          </div>
          <div className="mt-8 flex space-x-4">
            <Button
              type="button"
              onClick={stayLoggedIn}
              maxWidth="full"
              width="170px"
              variant="outline"
            >
              Stay Logged In
            </Button>
            <Button
              type="button"
              onClick={logOut}
              maxWidth="full"
              width="170px"
            >
              Logout
            </Button>
          </div>
        </Box>
      </Modal>
    </>
  );
};
